import { render, staticRenderFns } from "./ReporteDeAutoGestion.vue?vue&type=template&id=c63681da&scoped=true"
import script from "./ReporteDeAutoGestion.vue?vue&type=script&lang=js"
export * from "./ReporteDeAutoGestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c63681da",
  null
  
)

export default component.exports